if (!customElements.get("product-form")) {
	customElements.define(
		"product-form",
		class ProductForm extends HTMLElement {
			constructor() {
				super();

				this.form = this.querySelector("form");
				this.form.querySelector("[name=id]").disabled = false;
				this.form.addEventListener(
					"submit",
					this.onSubmitHandler.bind(this)
				);
				if (this.querySelector("floating-form")) {
					window.addEventListener(
						"scroll",
						this.onScrollHandler.bind(this)
					);
				}
				this.cart =
					document.querySelector("cart-notification") ||
					document.querySelector("cart-drawer");
				this.submitButton = this.querySelector('[type="submit"]');
				if (document.querySelector("cart-drawer") && this.submitButton)
					this.submitButton.setAttribute("aria-haspopup", "dialog");
			}

			onScrollHandler() {
				const atc = this.querySelector(
					".product-form__buttons.static_form"
				);
				var isVisible = atc.getBoundingClientRect().bottom >= 150;
				if (isVisible) {
					document
						.querySelector("main")
						.classList.remove("floating-form-is-active");
				} else {
					document
						.querySelector("main")
						.classList.add("floating-form-is-active");
				}
			}

			onSubmitHandler(evt) {
				evt.preventDefault();
				if (this.submitButton.getAttribute("aria-disabled") === "true")
					return;

				if (!this.form.reportValidity()) return;

				this.handleErrorMessage();

				this.submitButton.setAttribute("aria-disabled", true);
				this.submitButton.classList.add("loading");
				this.querySelector(
					".loading-overlay__spinner"
				)?.classList.remove("hidden");

				const config = fetchConfig("javascript");
				config.headers["X-Requested-With"] = "XMLHttpRequest";
				delete config.headers["Content-Type"];

				const formData = new FormData(this.form);
				if (this.cart) {
					formData.append(
						"sections",
						this.cart
							.getSectionsToRender()
							.map((section) => section.id)
					);
					formData.append("sections_url", window.location.pathname);
					this.cart.setActiveElement(document.activeElement);
				}
				config.body = formData;

				fetch(routes.cart_add_url, config)
					.then((response) => response.json())
					.then((response) => {
						if (response.status) {
							this.handleErrorMessage(response.description);

							const soldOutMessage =
								this.submitButton.querySelector(
									".sold-out-message"
								);
							if (!soldOutMessage) return;
							this.submitButton.setAttribute(
								"aria-disabled",
								true
							);
							this.submitButton
								.querySelector("span")
								.classList.add("hidden");
							soldOutMessage.classList.remove("hidden");
							this.error = true;
							return;
						} else if (!this.cart) {
							window.location = window.routes.cart_url;
							return;
						}

						this.error = false;
						// WITHOUT GWP :
						// this.cart.renderContents(response);
						checkGWP(null, (responseNew) =>
							this.cart.renderContents(response, responseNew)
						);
					})
					.catch((e) => {
						console.error(e);
					})
					.finally(() => {
						this.submitButton.classList.remove("loading");
						if (
							this.cart &&
							this.cart.classList.contains("is-empty")
						)
							this.cart.classList.remove("is-empty");
						if (!this.error)
							this.submitButton.removeAttribute("aria-disabled");
						this.querySelector(
							".loading-overlay__spinner"
						)?.classList.add("hidden");
					});
			}

			handleErrorMessage(errorMessage = false) {
				this.errorMessageWrapper =
					this.errorMessageWrapper ||
					this.querySelector(".product-form__error-message-wrapper");
				if (!this.errorMessageWrapper) return;
				this.errorMessage =
					this.errorMessage ||
					this.errorMessageWrapper.querySelector(
						".product-form__error-message"
					);

				this.errorMessageWrapper.toggleAttribute(
					"hidden",
					!errorMessage
				);

				if (errorMessage) {
					this.errorMessage.textContent = errorMessage;
				}
			}
		}
	);
}

if (!customElements.get("variant-selectors")) {
	customElements.define(
		"variant-selectors",
		class VariantSelectors extends HTMLElement {
			constructor() {
				super();
			}

			getVariantData() {
				this.variantData =
					this.variantData ||
					JSON.parse(
						this.querySelector('[type="application/json"]')
							.textContent
					);
				this.variantData.forEach((variant) => {
					if (!variant.options.includes(variant.option0)) {
						variant.options.unshift(variant.option0);
					}
				});
				return this.variantData;
			}

			updateOptions() {
				var options = [""];
				this.querySelectorAll("select").forEach((elm) => {
					options[elm.dataset.option] = elm.value;
				});

				this.querySelectorAll("fieldset").forEach((elm) => {
					options[elm.dataset.option] =
						elm.querySelector("input:checked").value;
				});
				return options;
			}
		}
	);

	class VariantSelects extends HTMLElement {
		constructor() {
			super();
			this.addEventListener("change", this.onVariantChange);
			this.container = document.querySelector("variant-selectors");
			this.variantData = this.container.getVariantData();
			this.productInfo = [];
			if (this.dataset.splitProd) this.sortOptions();
			this.options = this.container.updateOptions();
			this.updateMasterId();
			this.setActiveColor();
			const _self = this;
			document.addEventListener("swiper-loaded", function (event) {
				_self.setActiveSlide();
			});
		}

		onVariantChange() {
			this.options = this.container.updateOptions();
			this.updateMasterId();
			this.toggleAddButton(true, "", false);
			this.removeErrorMessage();
			if (!this.currentVariant) {
				this.toggleAddButton(true, "", true);
				this.setUnavailable();
			} else {
				this.updateURL();
				this.updateVariantInput();
				this.renderProductInfo();
				this.setActiveSlide();
				this.setActiveColor();
				this.setLowStockAlert();
			}
		}

		sortOptions() {
			var _this = this;
			var select = this.querySelector("select");
			if (select) {
				var options = select.options;
				var savedSelectedOption = select.value;
				var optionsArray = [];
				for (var i = 0; i < options.length; i++) {
					optionsArray.push(options[i]);
				}
				optionsArray = optionsArray.sort(function (a, b) {
					if (_this.isNumeric(a.text)) {
						return a.text == b.text
							? 0
							: +a.text < +b.text
							? -1
							: 1;
					}
					return a.text == b.text ? 0 : a.text < b.text ? -1 : 1;
				});
				for (var i = 0; i <= options.length; i++) {
					options[i] = optionsArray[i];
				}
				select.value = savedSelectedOption;
			}
		}

		setActiveColor() {
			if (document.querySelector("[data-perso-preview]")) {
				this.currentVariant.options.forEach((option) => {
					let optionLower = option.toLowerCase();
					if (optionLower.includes("rose")) {
						this.activeColor = "rose";
					} else if (
						optionLower.includes("white") ||
						optionLower.includes("silver")
					) {
						this.activeColor = "silver";
					} else {
						this.activeColor = "gold";
					}
				});
				document.querySelector("[data-perso-preview]").dataset.color =
					this.activeColor;
			}
		}

		isNumeric(str) {
			if (typeof str != "string") return false;
			return !isNaN(str) && !isNaN(parseFloat(str));
		}

		updateMasterId() {
			this.currentVariant = this.variantData.find((variant) => {
				return !variant.options
					.map((option, index) => {
						return this.options[index] === option;
					})
					.includes(false);
			});
		}

		updateURL() {
			if (!this.currentVariant || !this.currentVariant.product_url)
				return;
			if (this.currentVariant.tags.includes("reload_variant"))
				window.location.href = `${this.currentVariant.product_url}?variant=${this.currentVariant.id}`;
			window.history.replaceState(
				{},
				"",
				`${this.currentVariant.product_url}?variant=${this.currentVariant.id}`
			);
		}

		updateVariantInput() {
			const productForms = document.querySelectorAll(
				`#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`
			);
			productForms.forEach((productForm) => {
				const input = productForm.querySelector('input[name="id"]');
				input.value = this.currentVariant.id;
				input.dispatchEvent(new Event("change", { bubbles: true }));
			});
		}

		removeErrorMessage() {
			const section = this.closest("section");
			if (!section) return;

			const productForm = section.querySelector("product-form");
			if (productForm) productForm.handleErrorMessage();
		}

		renderProductInfo() {
			if (this.currentVariant.available) {
				document
					.getElementById(
						`product-form-container-${this.dataset.section}`
					)
					.classList.remove("unavailable");
			} else {
				document
					.getElementById(
						`product-form-container-${this.dataset.section}`
					)
					.classList.add("unavailable");
			}
			if (
				this.currentVariant.compare_at_price &&
				this.currentVariant.compare_at_price > this.currentVariant.price
			) {
				document
					.getElementById(`price-${this.dataset.section}`)
					.classList.add("price--on-sale");
				document.querySelector(
					`#price-${this.dataset.section} .price__sale .price-item--regular`
				).innerHTML = formatMoney(this.currentVariant.compare_at_price);
				document.querySelector(
					`#price-${this.dataset.section} .price__sale .price-item--sale`
				).innerHTML = formatMoney(this.currentVariant.price);
			} else {
				document
					.getElementById(`price-${this.dataset.section}`)
					.classList.remove("price--on-sale");
			}
			document.querySelector(
				`#price-${this.dataset.section} .price__regular .price-item--regular`
			).innerHTML = formatMoney(this.currentVariant.price);
			document.querySelector(".floating_price").innerHTML = formatMoney(
				this.currentVariant.price
			);

			document.getElementById(`Sku-${this.dataset.section}`).innerHTML =
				this.currentVariant.sku;

			this.toggleAddButton(
				!this.currentVariant.available,
				window.variantStrings.soldOut
			);

			document
				.querySelectorAll(".product__info-container [data-option]")
				.forEach((element) => {
					element.querySelector(".value")
						? (element.querySelector(".value").innerHTML =
								this.currentVariant[
									"option" + element.dataset.option
								])
						: null;
				});
		}

		setActiveSlide() {
			const mediaId = this.currentVariant?.featured_media?.id;
			const mediaSlide = document.querySelector(
				`.product-media-full-container .swiper-slide[data-media-id="${mediaId}"]`
			);
			if (mediaSlide) {
				const slider = document.querySelector(
					"#product-media.swiper .product-media-full-container .overflow-container"
				)?.swiper;
				slider?.slideTo(mediaSlide.dataset.slideIndex, 0);
			}
		}

		toggleAddButton(disable = true, text, modifyClass = true) {
			const productForm = document.getElementById(
				`product-form-${this.dataset.section}`
			);
			if (!productForm) return;
			const addButton = productForm.querySelector('[name="add"]');
			const addButtonText = productForm.querySelector(
				'[name="add"] > span'
			);
			if (!addButton) return;

			if (disable) {
				addButton.setAttribute("disabled", "disabled");
				if (text) addButtonText.textContent = text;
			} else {
				addButton.removeAttribute("disabled");
				addButtonText.textContent = window.variantStrings.addToCart;
			}

			if (!modifyClass) return;
		}

		setUnavailable() {
			const button = document.getElementById(
				`product-form-${this.dataset.section}`
			);
			const addButton = button.querySelector('[name="add"]');
			const addButtonText = button.querySelector('[name="add"] > span');
			const price = document.getElementById(
				`price-${this.dataset.section}`
			);
			if (!addButton) return;
			addButtonText.textContent = window.variantStrings.unavailable;
			if (price) price.classList.add("visibility-hidden");
		}

		setLowStockAlert() {
			const alerts = document.querySelectorAll(".low-stock-alert");
			if (!alerts) return;
			alerts.forEach((alert) => {
				alert.hidden = alert.dataset.variantId != this.currentVariant.id;
			})
		}
	}

	customElements.define("variant-selects", VariantSelects);

	class VariantRadios extends VariantSelects {
		constructor() {
			super();
		}
		sortOptions() {
			this.querySelectorAll(".wrapper").forEach((wrapper) => {
				Array.prototype.slice
					.call(wrapper.querySelectorAll(".swatch_container"))
					.sort(function sort(ea, eb) {
						const type = ea.dataset.type;
						var a = ea.dataset.label.trim().toLowerCase();
						var b = eb.dataset.label.trim().toLowerCase();
						// Sort based on the "color" type
						if (type == "color") {
							// Strings containing "gold", but not "14" or "10", are sorted first
							if (
								a.includes("gold") &&
								!a.includes("14") &&
								!a.includes("10")
							) {
								return -1;
							}
							if (
								b.includes("gold") &&
								!b.includes("14") &&
								!b.includes("10")
							) {
								return 1;
							}

							// Strings containing "silver", but not "14" or "10", are sorted second
							if (
								a.includes("silver") &&
								!a.includes("14") &&
								!a.includes("10")
							) {
								return -1;
							}
							if (
								b.includes("silver") &&
								!b.includes("14") &&
								!b.includes("10")
							) {
								return 1;
							}

							// Strings not containing "14" or "10" are sorted third
							if (!a.includes("14") && !a.includes("10")) {
								return -1;
							}
							if (!b.includes("14") && !b.includes("10")) {
								return 1;
							}

							// If all previous comparisons failed, return 0 (no change in order)
							return 0;
						}
						// Sort based on the other types
						else {
							if (a < b) return -1;
							if (a > b) return 1;
							return 0;
						}
					})
					.forEach(function (div) {
						div.parentElement.appendChild(div);
					});
			});
		}
	}

	customElements.define("variant-radios", VariantRadios);
}

if (!customElements.get("perso-fav")) {
	customElements.define(
		"perso-fav",
		class Personalization extends HTMLElement {
			constructor() {
				super();
				this.input = this.querySelector("input");
				this.count = this.querySelector("[data-perso-charac-count]");
				this.preview = this.querySelector("[data-perso-preview]");

				this.input.addEventListener(
					"input",
					this.onInputType.bind(this)
				);
			}

			onInputType() {
				this.value = this.input.value;
				if (this.value != "") {
					this.classList.add("has-perso");
				} else {
					this.classList.remove("has-perso");
				}
				this.count.innerHTML = this.value.length;
				if(this.preview){
					this.preview.innerHTML = this.value;
				}
			}
		}
	);
}
